import ConfigureClusterManager from '../../pages/ConfigureClusterManager'
import DockerClusterManager from '../../pages/DockerClusterManager'
import DockerDatabase from '../../pages/DockerDatabase'
import DockerStartClusterManager from '../../pages/DockerStartClusterManager'
import InstallDatabase from '../../pages/InstallDatabase'
import { createDescriptor, PageDescriptor } from '../../pages/types'
import StartClusterManager from '../../pages/StartClusterManager'
import StartComputeServer from '../../pages/StartComputeServer'
import { ServerBrick } from './ServerBrick'
import { ReactNode } from 'react'

export class ClusterManagerBrick extends ServerBrick {
    private container: boolean
    private orchestrated: boolean

    constructor(container: boolean, orchestrated: boolean = false) {
        super()
        this.container = container
        this.orchestrated = orchestrated
    }

    public key(): string { 
        return 'cm' 
    }

    public isContainer(): boolean {
        return this.container
    }

    public isOrchestrated(): boolean {
        return this.orchestrated
    }

    get title(): string {
        return 'Cluster Manager'
    }

    get sortIndex(): number {
        return 3
    }

    *getPages(): Generator<PageDescriptor> {
        const { container: isContainer } = this
        if(this.container) {
            yield createDescriptor(DockerDatabase, {})
            yield createDescriptor(DockerClusterManager, {})
            yield createDescriptor(ConfigureClusterManager, { isContainer })
            if(!this.orchestrated) {
                yield createDescriptor(DockerStartClusterManager, {})
            }
        } else {
            yield createDescriptor(InstallDatabase, {})
            yield createDescriptor(ConfigureClusterManager, { isContainer })
            yield createDescriptor(StartClusterManager, { })
            yield createDescriptor(StartComputeServer, { })
        }
    }

    public describe(): ReactNode
    {
       return <p>The <b>Cluster Manager</b> runs in your environment {this.container ? "inside a container" : "on a (virtual) machine"}.
        It does not require a license, uses a database for storing state and provides a web interface for managing your cluster.        
        </p>        
    }
}
